/* tslint:disable:no-inferrable-types no-trailing-whitespace import-spacing typedef-whitespace align whitespace quotemark */

import { DocumentWindow }           from './document.window';
import { SearchMetadata }           from './search.metadata';
import { DocumentWindowManager }    from './document.window.manager';
import { Logger }                   from '@/util/logger';
import { BlobService }              from '@/services/blob.service';
import { IdeService }               from '@/services/ide.service';
import { FileBrowserMetadata }      from './file.browser.metadata';
import { ScenarioBrowserMetadata }  from './scenario.browser.metadata';
import { SearchCommand }            from './search.command';
import {PropertiesHolder}           from '@/models/properties.holder';
import {JSONBrowserMetadata}        from './json.browser.metadata';
import {TextEditorMetadata}         from './text.editor.metadata';

import {
  Blob as FileBlob,
  BlobType
}                                   from '@/models/blob';

import * as $                       from 'jquery';

import 'ag-grid-community';

import { first                 }    from 'rxjs/operators';

import {UnDoRedo} from "@/util/un.do.redo";
import {ICommand} from "@/util/i.command";

import {basename, errorAsText} from "@/util/util";

import {
  createGrid,
  GridApi,
  GridOptions,
  IRowNode,
  RowClickedEvent
} from 'ag-grid-community';

/**
 *
 * @class SearchWindow
 *
 * @brief window for general blob searching and quick view.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class SearchWindow extends DocumentWindow {

  /** access to the virtual file system */
  private blobber:           BlobService = null;

  /** access to user authentication */
  private ide:                IdeService = null;

  /** the document manager we are a tab  of */
  private manager: DocumentWindowManager = null;

  /** the current search pattern */
  private search:                 string = '';

  /** the API for the widget */
  private api: GridApi                   = null;

  /** are we showing hidden files? */
  private showHidden:            boolean = false;

  /** case-insensitive searching? */
  private caseSensitve:          boolean = true;

  /** search style, simple, explicit, regex */
  private mode:                   string = 'explicit';

  /** results to show per page */
  private pageSize:               number = 50;

  /** timer to wait for user to stop typing */
  private typingTimer = null;

  /** the history manager for the diversion editor */
  public undoManager:           UnDoRedo = new UnDoRedo(`FileBrowserHistory`);

  /** standard constructor */
  constructor(
       meta: SearchMetadata,
    manager: DocumentWindowManager
  ) {

    super(manager, meta, manager.layoutManager());

    Logger.debug('[SearchWindow] constructing...');

    this.manager     = manager;
    this.blobber     = this.manager.blobService();
    this.ide         = this.manager.ideService();
    this.search      = meta.search;

    this.showBrowser();
  }

  /** restore the search view (on current 'focus') */
  public showBrowser() {

    Logger.debug(`[SearchWindow] => ${this.search} ...`);

    const container: JQuery<HTMLElement> = $(`#${this.meta.id}`);

    if (!$(container) || !$(container).is('div')) {

      this.unReady();

      Logger.error(`[SearchWindow] missing hosting container (${this.meta.id})!`);

      return ;
    }

    $(container).html(`
<div class="gui-search-browser-wrapper">

<div class="add-blob-dialog-quickaction">
<label
  id="browse-search-back-click-${this.meta.id}"
  class="gui-button"
  title="Previous Search">
  <i class="fas fa-arrow-left"></i>
</label>
<label
  id="browse-search-forward-click-${this.meta.id}"
  class="gui-button"
  title="Next Search">
  <i class="fas fa-arrow-right" ></i>
</label>
<label
  id="browse-search-hidden-click-${this.meta.id}"
  class="gui-button primary"
  title="Show hidden files">
  <i class="far fa-eye-slash" ></i>
</label>

<label
  id="browse-dropcase-hidden-click-${this.meta.id}"
  class="gui-button"
  title="Case insensitive search">
  <i class="fas fa-remove-format" ></i>
</label>

<label
  id="browse-search-refresh-click-${this.meta.id}"
  class="gui-button"
  title="Refresh display">
  <i class="fas fa-sync-alt"></i>
</label>

<label
  id="search-mode-exact-click-${this.meta.id}"
  class="gui-button search-mode-toggle-${this.meta.id} primary"
  data-mode="explicit"
  title="Search mode: Exact">
  exact
</label>

<label
  id="search-mode-simple-click-${this.meta.id}"
  class="gui-button search-mode-toggle-${this.meta.id}"
  data-mode="simple"
  title="Search mode: Simple (* and ?)">
  simple
</label>

<label
  id="search-mode-regex-click-${this.meta.id}"
  class="gui-button search-mode-toggle-${this.meta.id}"
  data-mode="regex"
  title="Got Milk?">
  regex
</label>


<input
  id="page-size-input-${this.meta.id}"
  class="gui-input search-mode-input"
  style="width: 30px"
  type="text"
  title="results page size"
  placeholder="50" value="50">

</div>

<div class="browse-search-path" style="margin-top: 12px;">
<input
  id="browse-search-input-${this.meta.id}"
  class="gui-input browse-search-input search-mode-input"
  style="width: 100%;"
  type="text"
  title="Enter a search pattern..."
  placeholder="Enter a search pattern...">
</div>

<div class="gui-error-line"></div>

<div id="grid_search_table_${this.meta.id}" class="browse-ag-grid-wrap ag-theme-balham-dark">

</div>

</div>`);

    const checkExist = setInterval(() => {

      const dom: HTMLElement = document.getElementById(`grid_search_table_${this.meta.id}`) as HTMLElement;

      if (dom) {

        clearInterval(checkExist);

        /* setup quick actions */

        $(`#browse-search-back-click-${this.meta.id}`).on('click', () => {

          if (this.undoManager.undoSize() === 0) {

            return ;
          }

          this.undoManager.undo();
        });

        $(`#browse-search-forward-click-${this.meta.id}`).on('click', () => {

          if (this.undoManager.redoSize() === 0) {

            return ;
          }

          this.undoManager.redo();
        });

        $(`#browse-dropcase-hidden-click-${this.meta.id}`).on('click', () => {

          /* go! */

          $(`#browse-dropcase-hidden-click-${this.meta.id}`).removeClass('primary');

          this.caseSensitve = !this.caseSensitve;

          if(!this.caseSensitve) {

            $(`#browse-dropcase-hidden-click-${this.meta.id}`).addClass('primary');
          }

          this.navigate(this.search);
        });

        $(`#browse-search-hidden-click-${this.meta.id}`).on('click', () => {

          /* go! */

          $(`#browse-search-hidden-click-${this.meta.id}`).removeClass('primary');

          this.showHidden = !this.showHidden;

          if(!this.showHidden) {

            $(`#browse-search-hidden-click-${this.meta.id}`).addClass('primary');
          }

          this.navigate(this.search);

        });

        $(`#browse-search-refresh-click-${this.meta.id}`).on('click', () => {

          /* go! */

          this.navigate(this.search);

        });

        $(`.search-mode-toggle-${this.meta.id}`).on('click', (e) => {

          $(`.search-mode-toggle-${this.meta.id}`).removeClass('primary');

          $(e.currentTarget).addClass('primary');

          this.mode = $(e.currentTarget).data('mode');

          this.navigate(this.search);
        });

        // noinspection JSJQueryEfficiency
        $(`#browse-search-input-${this.meta.id}`).on('input', (e) => {

          /* typing wait: @link https://stackoverflow.com/questions/10124114/wait-for-function-till-user-stops-typing */

          if (this.typingTimer) {

            clearTimeout(this.typingTimer);
          }

          this.typingTimer = setTimeout(() => {

            const search: string = $(e.currentTarget).val() as string;

            this.navigate(search);

          }, 400);

        });

        // noinspection JSJQueryEfficiency
        $(`#browse-search-input-${this.meta.id}`).on('keypress', (e) => {

          if (this.typingTimer) {

            clearTimeout(this.typingTimer);
          }

          this.typingTimer = setTimeout(() => {

            const search: string = ($(e.currentTarget).val() as string).trim();

            this.navigate(search);

          }, 400);

        });

        /* setup Ag-Grid (table browser) */

        const columnDefs = [
          {
            valueGetter: '',
            dndSource: true,
            width: 32,
            dndSourceOnRowDrag: (params: any): void => {

              const row = params.rowNode;
              const e   = params.dragEvent;

              /* make sure this row is now the current selection */

              row.setSelected(true, true);

              /* fetch the current selection into transfer data */

              const transferRows: any = [];

              this.api.getSelectedRows().forEach((node) => {

                transferRows.push({
                  key: node.key,
                  name: node.name,
                  type: node.type,
                  icon: node.icon,
                  date: node.date,
                  size: node.size,
                  owner: node.owner
                });

              });

              /* encode as JSON */

              const jsonData          = JSON.stringify(transferRows);

              /* publish the data */

              if (window.navigator.userAgent.indexOf('Trident/') >= 0) {

                /* Internet Explorer is 'special' */

                e.dataTransfer.setData('text', jsonData);

              } else {

                e.dataTransfer.setData('application/json', jsonData);
                e.dataTransfer.setData('text/plain', jsonData);
              }

            }
          },
          {headerName: 'Name', field: 'name'},
          {
            headerName: 'Date',
            field:      'date',
            comparator: (a, b) => {

              if (!a || a === '') {
                return -1;
              }

              if (!b || b === '') {

                return 1;
              }

              // @ts-ignore
              const ap: number[] = a.split(/[- :]/).map(x => x as number);

              // @ts-ignore
              const bp: number[] = b.split(/[- :]/).map(x => x as number);

              const aDate = new Date(Date.UTC(ap[0], ap[1]-1, ap[2], ap[3], ap[4], ap[5]));
              const bDate = new Date(Date.UTC(bp[0], bp[1]-1, bp[2], bp[3], bp[4], bp[5]));

              if(aDate > bDate) {
                return 1;
              }

              if(bDate > aDate) {

                return -1;
              }

              return 0;
            }
          },
          {headerName: 'Size',  field: 'size'},
          {
            headerName: 'Type',
            field:      'type'
          },
          {headerName: 'Owner', field: 'owner'},
          {headerName: 'Full Path', field: 'key'}

        ];

        const rowData = [];

        const gridOptions: GridOptions = {
          columnDefs,
          rowData,
          rowDragManaged: true,
          defaultColDef: {
            sortable:              true,
            resizable:             true,
            cellRenderer:  (params: any) => {

              if (params.colDef.field !== 'name') {

                return params.value;
              }

              let title: string = params.data.name;

              if (this.search === '') {

                return params.data.icon + title;
              }

              if (this.mode === 'explicit' || this.mode === 'regex') {

                let flags: string = '';

                if(this.mode === 'regex') {

                  if (!this.caseSensitve) {

                    flags = 'i';
                  }
                }

                /* reconstruct the pattern the backend would have used */

                const pattern = new RegExp(this.search, flags);

                title = title.replace(pattern, `<span style="background-color: #dce305; color: black;">${this.search}</span>`);

              } else if (this.mode === 'simple') {

                /* reconstruct the pattern the backend would have used */

                let term = this.search;
                term = term.replace('*', '.*');
                term = term.replace('?', '.');

                let flags: string = '';

                if (!this.caseSensitve) {

                  flags = 'i';
                }

                const pattern = new RegExp(term, flags);

                title = title.replace(pattern, `<span style="background-color: #dce305; color: black;">${this.search}</span>`);

              }

              return params.data.icon + title;

            }
          },
          rowSelection:                   'multiple',
          enableCellTextSelection:        true,
          suppressRowDeselection:         true,
          animateRows:                    true,
          enableRangeSelection:           true,
          allowContextMenuWithControlKey: true,
          popupParent:                    document.querySelector('body'),

          onRowClicked: (row: RowClickedEvent): void => {

            const ph: PropertiesHolder = new PropertiesHolder();
            const data                 = row.data;

            ph.icon  = data.icon;
            ph.title = data.name;

            ph.set('Name', data.name);
            ph.set('Path', data.key);

            if (data.type !== 'folder') {

              ph.set('Date', data.date);
              ph.set('Size', data.size);
              ph.set('Type', data.type);
              ph.set('Owner', data.owner);
            }

            this.ide.focus(ph);
          },

          onCellContextMenu: (row) => {

            const node = row.node;

            if (!node.isSelected()) {

              this.api.deselectAll();

              node.setSelected(true, true);
            }

          },

          onGridReady: (data) => {

            this.api = data.api;

            this.navigate(this.search);

          },
          getContextMenuItems: (params) => {

            let menu: any[] = [];

            menu = menu.concat([

              {
                name: 'Browse Scenario',
                action: () => {

                  this.ide.launchWindow(new ScenarioBrowserMetadata(
                    '',
                    '',
                    params.node.data.key
                  ));
                },
                icon: '<i class="fas fa-table"></i>'
              },

              /*
              {
                name: 'View String Lines',
                action: () => {

                  this.ide.launchWindow(new StringLineViewerMetadata(
                    '',
                    '',
                    params.node.data.key,
                    '<i class="fas fa-train"></i>'
                  ));
                },
                icon: '<i class="fas fa-train"></i>'
              },
              */

              {
                name: 'JSON Edit',
                action: () => {

                  this.ide.launchWindow(new JSONBrowserMetadata(
                    '',
                    '',
                    params.node.data.key,
                    'json',
                    basename(params.node.data.key),
                    '<i class="fas fa-edit"></i>'
                  ));
                },
                icon: '<i class="fas fa-edit"></i>'
              },

              {
                name: 'Raw Edit',
                action: () => {

                  this.ide.launchWindow(new TextEditorMetadata(
                    '',
                    '',
                    params.node.data.key
                  ));
                },
                icon: '<i class="fas fa-keyboard"></i>'
              },
              {
                name: 'Open Folder',
                action: () => {

                  const file: string   = params.node.data.key;
                  const folder: string = file.replace(/\\/g, '/')
                    .replace(/\/[^/]*\/?$/, '');

                  /* build the meta for a file browser preloaded to parent */

                  const  meta: FileBrowserMetadata = new FileBrowserMetadata('', '', folder);

                  /* launch the  new window */

                  this.ide.launchWindow(meta);
                },
                icon: '<i class="fas fa-external-link-alt"></i>'
              },
              {
                name: 'Download',
                action: () => {

                  this.downloadFile(params.node);

                },
                // @ts-ignore
                disabled: params.node.type === 'folder',
                icon: '<i class="fas fa-file-download"></i>'
              },
              'separator',
              'copy',
              'export'
            ]);

            return menu;
          },

        };

        this.api = createGrid(dom, gridOptions);

      }

    }, 100);
  }

  private downloadFile(node: IRowNode): void {

    if (node.data.type === 'folder') {

      Logger.error(`[FileBrowserWindow] tried to download folder: `, node);

      return  ;
    }

    const  key:   string = node.data.key;
    const type: BlobType = FileBlob.guessType(FileBlob.typeofString(node.data.type), node.data.key, node.data.name);
    let   mime: string   = 'application/octet-stream';
    let    txt: boolean  = false;

    let keyBase          = key.substring(key.lastIndexOf('/') + 1);

    if(!keyBase || keyBase === '' ) {

      keyBase = key;
    }

    /*
     * everything gets downloaded as binary data, but if it reasonably looks like JSON
     * data, download it as such.
     *
     */

    if (type !== BlobType.None && type !== BlobType.File) {

      /* our own file types are all JSON based */

      mime = 'application/json';
      txt  = true;

    } else {

      if (/\.json$/i.test(key)||/\.json$/i.test(keyBase)) {

        mime = 'application/json';
        txt  = true;
      }

      if (/\.csv/i.test(key)||/\.csv$/i.test(keyBase)) {

        mime = 'text/csv';
        txt  = true;
      }
    }

    /* fetch the blob */

    this.api.showLoadingOverlay();

    this.blobber.contents(key, 'latest', txt ? 'text' : 'blob')
      .pipe(first())
      .subscribe({
        next: (content: any) => {

          this.api.hideOverlay();

          Logger.debug(`[SearchWindow] downloading ${keyBase} => ${mime}`);

          let blob: Blob = null;

          if (typeof content === 'string') {

            /* it was presumed to be text */

            blob = new Blob([content], {type: mime});

          } else {

            /* its taken as a binary blob */

            blob = content as Blob;
          }

          const url = window.URL.createObjectURL(blob);

          /* set up a fake one-time link with the right download name and the blob attached as the download */

          const element: HTMLAnchorElement = document.createElement('a');
          element.href = url;
          element.download = keyBase || 'download';

          element.style.display = 'none';

          document.body.appendChild(element);

          /* do it */

          element.click();

          /* clean up */

          document.body.removeChild(element);

        },
        error: (err) => {

          this.api.hideOverlay();

          Logger.error(`[SearchWindow] can't find content ${key}: `, errorAsText(err));
        }

      });

  }

  /** helper to make sure the navigation buttons are in the right state */
  public updateNavButtons() {

    /* update the navigation buttons */

    const    back: JQuery = $(`#browse-search-back-click-${this.meta.id}`);
    const forward: JQuery = $(`#browse-search-forward-click-${this.meta.id}`);

    $(back).removeClass('disabled');
    $(forward).removeClass('disabled');

    if (this.undoManager.undoSize() === 0) {

      $(back).addClass('disabled');
    }

    if (this.undoManager.redoSize() === 0) {

      $(forward).addClass('disabled');
    }
  }

  /** wrapper for 'go' that tracks it with history, so we can do back/forward navigation */
  public navigate(text: string) {

    /* do we actually have new history? */

    if ((text === this.search) && (this.undoManager.undoSize() === 0)) {

      /* it's the same thing, just refresh */

      this.go(text);

      return ;
    }

    /* track the navigation history... */

    Logger.debug('[SearchWindow] navigating to: ', text);

    const cmd: ICommand        = new SearchCommand(this.search, text, this);

    /* use the command to do the navigation */

    cmd.execute();

    this.undoManager.insert(cmd);
  }

  /** search! */
  public go(search: string, offset:number = 0) {

    this.api.showLoadingOverlay();

    // tslint:disable-next-line:max-line-length
    Logger.debug(`[SearchWindow] searching: term=${this.search} mode=${this.mode} cs=${this.caseSensitve} of=${offset} sz=${this.pageSize}`);

    this.blobber.quickMatch(
      search,
      this.mode,
      this.caseSensitve,
      offset,
      this.pageSize)
      .pipe(first())
      .subscribe({
        next: (result: any) => {

          this.updateNavButtons();

          this.api.hideOverlay();

          /* show the results */

          this.updateFocus(search);

          let files = [];

          result.results.forEach((item: any) => {

            let icon: string;
            const type: BlobType = FileBlob.guessType(FileBlob.typeofString(item.type), item.key, item.name);

            if ((type !== BlobType.None) && (type !== BlobType.File)) {

              icon = '<img style="margin-right: 4px;" src="assets/images/blob-icons/' + FileBlob.iconOfType(type) + '">';

            } else {

              /* if we don't have a direct or extension based guessable type, it must be something else... */

              icon = '<img style="margin-right: 4px;" src="assets/images/blob-icons/' + FileBlob.iconOfType(BlobType.File) + '">';

              if (/\.json$/i.test(item.key) || /\.json$/i.test(item.name)) {

                icon = '<img style="margin-right: 4px;" src="assets/images/blob-icons/file-json-20.png">';

              }

              if (/\.csv$/i.test(item.key) || /\.csv$/i.test(item.name)) {

                icon = '<img style="margin-right: 4px;" src="assets/images/blob-icons/file-csv-20.png">';

              }
            }

            files.push({
              name: item.name,
              key: item.key,
              size: item.size,
              date: item.modified,
              type: item.type,
              owner: item.owner,
              icon
            });

          });

          if (!this.showHidden) {

            files = files.filter(x => !/^\./.test(x.name));
          }

          /* update the page navigation ... */

          this.api.setGridOption('rowData', files);

          this.api.applyColumnState({
            state: [{colId: 'name', sort: 'asc'}],
            defaultState: {sort: null}
          });

          this.api.sizeColumnsToFit();

          this.api.hideOverlay();

        },

        error: (err) => {

          this.updateNavButtons();

          this.api.hideOverlay();

          Logger.error('[SearchWindow] could not search: ', errorAsText(err));
        }

      });

  }

  /** update the focus to current */
  private updateFocus(search: string) {

    $(`#browse-search-input-${this.meta.id}`).val(search);

    this.search = search;
    this.title  = search;
  }

  private error(msg: string) {

    const display = $(`#${this.meta.id} .gui-error-line`);

    $(display).html(msg);
  }

}
